// extracted by css-extract-rspack-plugin
export default {"crumbs":"eyGsqgrFfPENJiZj","crumb":"nIQ7yUgURxwmyPx2","separator":"_7NvKuBsz3ImoT7H"};